import { useEffect, useState } from 'react';
import { ResponsiveVariant } from 'src/tef/components/utils/types';

export function useResponsiveVariant<T>(variant: ResponsiveVariant<T>): T {
  const getInitialValue = (): T => {
    if (typeof variant === 'object' && variant !== null && 'base' in variant) {
      return (variant.base ?? variant.sm ?? variant.md ?? variant.lg ?? variant.xl ?? variant.base) as T;
    }
    return variant as T;
  };

  const [currentVariant, setCurrentVariant] = useState<T>(getInitialValue);

  useEffect(() => {
    if (typeof variant !== 'object' || variant === null || !('base' in variant)) {
      setCurrentVariant(variant as T);
      return;
    }

    const updateVariant = () => {
      const width = window.innerWidth;

      if (width >= 1280 && variant.xl) {
        setCurrentVariant(variant.xl);
      } else if (width >= 1024 && variant.lg) {
        setCurrentVariant(variant.lg);
      } else if (width >= 768 && variant.md) {
        setCurrentVariant(variant.md);
      } else if (width >= 640 && variant.sm) {
        setCurrentVariant(variant.sm);
      } else {
        setCurrentVariant(variant.base ?? variant.sm ?? variant.md ?? variant.lg ?? variant.xl ?? ({} as T));
      }
    };

    updateVariant();
    window.addEventListener('resize', updateVariant);

    return () => window.removeEventListener('resize', updateVariant);
  }, [variant]);

  return currentVariant;
}
